var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Crawlspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "DCOai~EZg8R0DMdmZQyRwa",
    x1: 14.188,
    x2: 34.817,
    y1: 2.661,
    y2: 59.337,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 22",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4943b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2620e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DCOai~EZg8R0DMdmZQyRwb",
    x1: 24,
    x2: 24,
    y1: 3.576,
    y2: 62.761,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 7",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9b4822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8f3c1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#8b3817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    stopColor: "#883515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#802d10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DCOai~EZg8R0DMdmZQyRwc",
    x1: 24,
    x2: 24,
    y1: 29.652,
    y2: 70.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34f27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#8b3817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#802d10"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#DCOai~EZg8R0DMdmZQyRwa)",
    d: "M43,41H5a2,2,0,0,1-2-2V20.23607a2,2,0,0,1,1.10557-1.78886L22.21115,8.39443a4,4,0,0,1,3.5777,0L43.89443,18.44721A2,2,0,0,1,45,20.23607V39A2,2,0,0,1,43,41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#DCOai~EZg8R0DMdmZQyRwb)",
    d: "M7,24V41H41V24a2,2,0,0,0-2-2H9A2,2,0,0,0,7,24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#DCOai~EZg8R0DMdmZQyRwc)",
    d: "M39,29H9V25H39Zm0,2H9v4H39Zm0,6H9v4H39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Crawlspace);
export default __webpack_public_path__ + "static/media/icons8-crawlspace.b1005713be116637992ec20e9429e18a.svg";
export { ForwardRef as ReactComponent };